<template>

  <div id="app">
      <search-bar ref="searchBarComponent" @searchBarHeight="getSearchBarHeight">
       <!-- <div slot="search-tool">
          <el-button class="item-btn el-icon-plus" type="primary" @click="handleEdit()">添加职位</el-button>
          <el-button class="item-btn c-btn-sub" @click="clearQuery">重置</el-button>

        </div> -->
        <div slot="search-cont">

          <div class="item" style="width: 18%;">
            <div class="item-label">状态</div>
            <el-select v-model="search.audit" size="small" slot="prepend" placeholder="请选择状态" @change="getList" style="width:130px">
              <el-option label="不限" value=""></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="审核不通过" value="3"></el-option>
              <el-option label="审核通过已上线" value="1"></el-option>
              <el-option label="已停招" value="5"></el-option>
              <el-option label="储备待招" value="4"></el-option>
            </el-select>
          </div>
          <div class="item" style="width: 18%;">
            <div class="item-label" >岗位类型</div>
            <el-select v-model="search.jobtype" size="small" slot="prepend" placeholder="请选择状态" @change="getList" style="width:130px">
              <el-option label="不限" value=""></el-option>
              <el-option label="主推职位" value="1"></el-option>
              <el-option label="热推职位" value="2"></el-option>
            </el-select>
          </div>

          <div class="item" style="width: 18%;">
            <div class="item-label" >代理招聘</div>
            <el-select v-model="search.is_agent_time_valid" size="small" slot="prepend" placeholder="请选择" @change="getList" style="width:130px">
              <el-option label="不限" value=""></el-option>
              <el-option label="进行中" value="1"></el-option>
              <el-option label="暂停" value="0"></el-option>
              <el-option label="未开启" value="2"></el-option>
              <el-option label="过期" value="3"></el-option>
            </el-select>
          </div>

          <div class="item" style="width: 30%;">
            <div class="item-label" >关键词搜索</div>
            <div style="width: 300px;">
              <el-input placeholder="请输入内容" v-model="search.key" class="input-with-select" size="small" @keyup.enter.native='searchKey'>
                <el-select v-model="search.key_type" slot="prepend" placeholder="请选择" @change="selectChange" style="width: 130px"
                  size="small">
                  <el-option label="公司名称" value="1"></el-option>
                  <el-option label="职位名称" value="2"></el-option>

                </el-select>
                <el-button slot="append" icon="el-icon-search" @click='searchKey' size="small"></el-button>
              </el-input>
            </div>
          </div>

        <!--  操作按钮 start -->
          <div class="item" style="width:16%;">
            <el-button class="item-btn" type="primary" @click="getList">查询</el-button>
            <el-button class="item-btn reset-btn" @click="clearQuery">重置</el-button>
          </div>
        <!--  操作按钮 end -->


        </div>
      </search-bar>

      <div class="operation-tool">
        <div @click="handleEdit()" class="tool-item"> <img src="../../../static/img/btn/add.png" /> 添加职位</div>
        <div @click="multiDelete()" class="tool-item"> <img src="../../../static/img/btn/delete.png" />删除职位</div>
        <div @click="handleSettingAgentRecuit()" class="tool-item"> <img src="../../../static/img/btn/log.png" /> 批量设置代理招聘</div>
        <div @click="showSettingPriceContactDialog()" class="tool-item"> <img src="../../../static/img/btn/log.png" /> 批量设置代理价格咨询电话</div>
      </div>

      <div class="l-panel">
        <div class="panel-body">
        <el-table class="l-table l-table-new" :max-height="300" :data="dataList" style="width: 100%;" stripe @selection-change="handleSelectionChange" size="mini">
          <el-table-column type="selection" width="100" align="left"></el-table-column>
          <el-table-column prop="jobs_name" label="招聘职位" align="left" width="300" >
            <template slot-scope="{row}">
              <div class="table-jobs-panel" @click="openJobsDetailsDialog(row.id)" >
                <div class="job-name" >
                  <span>{{row.district_cn1}}{{row.district_cn2}}{{row.district_cn3}}</span>
                  <el-divider direction="vertical"></el-divider>
                  <span>{{row.jobs_name}}</span>
                </div>
                <div class="wage" >
                  {{row.wage_cn}}<span >{{row.wage_cn_unit}}</span>
                </div>
                <div class="tags" >
                  <span  v-for="(item,index) in row.tag_cn" :key="index">{{item}}</span>
                </div>
              </div>

            </template>
          </el-table-column>
          <el-table-column prop="companyname" label="所属公司/工厂" align="left" width="300" >
            <template slot-scope="{row}">
              <div class="table-companyname" >{{row.companyname}}</div>
              <div class="table-company-type" >
                <span>{{row.trade_cn}}</span>
                <el-divider v-if="row.trade_cn" direction="vertical"></el-divider>
                <span>{{row.education_cn?row.education_cn:"学历不限"}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{row.experience_cn?row.experience_cn:"经验不限"}}</span>
                <el-divider direction="vertical"></el-divider>
                <span>{{row.amount}}人</span>
              </div>
            </template>
          </el-table-column>

          <!-- <el-table-column prop="agent_auth" label="允许代理招聘" align="left" width="110" >
            <template slot-scope="{row}">
              <el-link :underline="false" type="primary" v-if="row.agent_auth==1" >允许</el-link>
              <el-link :underline="false" type="danger" v-else >不允许</el-link>
              <el-button style="width: 50px;padding:4px 3px;" title="点击可设置" @click="sumbitSingleSettingAgentRecuit(row)" type="primary" size="mini">{{row.agent_auth==1?"不允许":"允许"}} </el-button>
            </template>
            <template slot-scope="{row}">
            <el-switch v-model="row.agent_auth" :active-value="1" :inactive-value="0" @change="sumbitSingleSettingAgentRecuit($event,row)" >
            </el-switch>
            </template>
          </el-table-column> -->

          <el-table-column prop="is_agent_time_valid" label="代理招聘" align="left" width="110" >
            <template slot-scope="{row}">
             <span v-if="row.is_agent_time_valid==1&&row.agent_auth==1" style="color: red;">进行中</span>
             <span v-if="row.is_agent_time_valid==0&&row.agent_auth==1" >过期</span>
             <span v-if="row.agent_auth==0" >暂停</span>
             <span v-if="row.agent_auth==2" >未开启</span>
            </template>
          </el-table-column>

          <el-table-column prop="jobs_name" label="代理价格" align="left"  >
            <template slot-scope="{row}">
              <el-link v-if="!row.agent_price" type="danger" @click="showPriceDialog(row)">未设置</el-link>
              <el-link v-else type="primary" @click="showPriceDialog(row)">查看</el-link>
            </template>
          </el-table-column>
          <el-table-column prop="" label="价格咨询电话" align="left"  width="110">
            <template slot-scope="{row}">
              <div>{{row.agent_price_contact}}</div>
              <div>{{row.agent_price_telephone}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="jobs_name" label="关联合同" align="left"  >
            <template slot-scope='{row}'>
              <span v-if="!row.contract_id" style="color: red;">未关联</span>
              <span v-else>{{row.c_companyname}}-{{row.project}}-{{row.contract_type_cn}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="audit" label="岗位状态" align="left"  >
            <template slot-scope='{row}'>
              <span v-if="row.audit==2" style="color: #409EFF;">{{row.audit_cn}}</span>
              <span v-else-if="row.audit==1" style="color: #00B333;">{{row.audit_cn}}</span>
              <span v-else>{{row.audit_cn}}</span>

            </template>
          </el-table-column>
          <el-table-column prop="jobtype_cn" label="岗位类型" align="left"  ></el-table-column>

          <el-table-column label="操作" width="170" align="right" >
            <template slot-scope="{row}">
              <div style="display: flex;justify-content: space-around;">

                <el-button type="primary"  @click="handleEdit(row.id)" size="mini">编辑</el-button>
                <el-button type="primary" @click="showDialogAudit(row.id)"   size="mini" >审核</el-button>
               <!-- <el-button type="danger" @click="showDialogRecommend(row.id)"  size="mini" >主推</el-button>
                <el-button type="primary" @click="refreshJobs(row.id)"  size="mini" >置顶</el-button> -->

               <!-- <el-button type="primary"  @click="deleteJobs(row.id)"  size="mini">删除</el-button> -->

               <el-popover placement="top" width="30" >
                 <div class="menu">
                   <span  @click="showDialogRecommend(row.id)" >主推</span>
                   <span @click="refreshJobs(row.id)" >置顶</span>
                 </div>
                 <el-button size="mini" slot="reference"><img class="more" src="@/images/index/1013213.png"
                     alt="" /></el-button>
               </el-popover>

             </div>
            </template>
          </el-table-column>


        </el-table>

        <div class="c-table-pager">
          <el-pagination @current-change="handleCurrentChange" :total="total" :page-size="20"></el-pagination>
        </div>
      </div>
    </div>





<!-- 审核弹窗start -->
    <el-dialog title="审核" :visible.sync="isShowDialogAudit" width="40%">
      <el-form :model="auditForm">
        <el-form-item label="状态" label-width="100px">
          <el-radio v-model="auditForm.audit" label="1">审核通过发布上线</el-radio>
          <el-radio v-model="auditForm.audit" label="3">审核不通过</el-radio>
          <el-radio v-model="auditForm.audit" label="4">审核通过暂不发布</el-radio>
          <el-radio v-model="auditForm.audit" label="5">暂停招聘</el-radio>
        </el-form-item>
        <el-form-item label="说明:" label-width="100px">
          <el-input type="textarea" rows="3" v-model="auditForm.remark" autocomplete="off"></el-input>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowDialogAudit = false">取 消</el-button>
        <el-button type="primary" @click="submitAudit">确 定</el-button>
      </div>
    </el-dialog>
<!-- 审核弹窗end -->

<!-- 审核弹窗start -->
    <el-dialog title="设置推荐职位" :visible.sync="isShowDialogRecommend" width="40%">
      <el-form :model="recommendForm">
        <el-form-item label="推荐类型:" label-width="100px">
          <el-radio v-model="recommendForm.jobtype" label="1">主推职位</el-radio>
          <el-radio v-model="recommendForm.jobtype" label="2">热招职位</el-radio>
          <el-radio v-model="recommendForm.jobtype" label="0">普通职位</el-radio>
        </el-form-item>

      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="isShowDialogRecommend = false">取 消</el-button>
        <el-button type="primary" @click="sumbitRecommend">确 定</el-button>
      </div>
    </el-dialog>
<!-- 审核弹窗end -->

<!-- 设置代理价格弹窗start -->
    <el-dialog class="el-dialog-larger" title="查看职位代理价格" :visible.sync="dialogVisiablePrice" >
      <el-row>
      <el-col :span="10">
        <el-card>
          <el-form :model="jobPriceInfo" label-width="130px" :rules="jobPriceInfoRules" ref="jobPriceInfo">
            <el-form-item label="员工入职时间" prop="agentPriceTime" >
              <el-date-picker v-model="jobPriceInfo.agentPriceTime" type="daterange" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 320px;">
              </el-date-picker>
            </el-form-item>

            <el-divider></el-divider>

            <!-- <el-form-item label="代理单价" prop="agent_price">
              <el-input v-model="jobPriceInfo.agent_price" type="number" :placeholder="'默认'+defaultPrice.agent_price"> <template slot="append">元/小时</template></el-input>
            </el-form-item> -->

            <div class="price" >
              <el-form-item label="代理单价" prop="agent_price"  >
                <el-input v-model="jobPriceInfo.agent_price" type="number" :placeholder="'默认'+defaultPrice.agent_price"  >
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="agent_price_unit"  style="margin-left:-120px">
              <el-select v-model="jobPriceInfo.agent_price_unit"   placeholder="请选择单位"    >
                <el-option label="元/时" :value="1"></el-option>
                <el-option label="元/月" :value="2"></el-option>
              </el-select>
              </el-form-item>
            </div>



            <el-form-item label="代理费用期" prop="agent_cost_period" >
              <el-input v-model="jobPriceInfo.agent_cost_period" type="number"> <template slot="append">个月</template></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <!-- <el-form-item label="代理开发费用" prop="price">
              <el-input v-model="jobPriceInfo.price" type="number" :placeholder="'默认'+defaultPrice.price"> <template slot="append">元/小时</template></el-input>
            </el-form-item> -->

            <div class="price" >
              <el-form-item label="代理开发费用" prop="price">
                <el-input v-model="jobPriceInfo.price" type="number" :placeholder="'默认'+defaultPrice.price" >
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="price_unit"  style="margin-left:-120px">
                <el-select v-model="jobPriceInfo.price_unit"   placeholder="请选择单位"     >
                  <el-option label="元/时" :value="1"></el-option>
                  <el-option label="元/月" :value="2"></el-option>
                </el-select>
             </el-form-item>
            </div>

           <!-- <el-form-item label="员工入职时间" prop="priceTime">
              <el-date-picker v-model="jobPriceInfo.priceTime" disabled type="daterange" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 320px;">
              </el-date-picker>
            </el-form-item> -->

            <el-form-item label="开发费用期" prop="cost_period">
              <el-input v-model="jobPriceInfo.cost_period" type="number"> <template slot="append">个月</template></el-input>
            </el-form-item>

            <el-form-item label="多少天起算费用" prop="calculate_days">
              <el-input v-model="jobPriceInfo.calculate_days" type="number">
              </el-input>
            </el-form-item>


            <el-form-item>
              <el-button type="primary" @click="submitAgentPrice('jobPriceInfo')">确 定</el-button>
              <el-button @click="dialogVisiablePrice = false">取 消</el-button>
            </el-form-item>



          </el-form>
        </el-card>
      </el-col>

      <el-col :span="14">
        <div class="l-panel">
                <div class="panel-body">
                  <div>历史记录</div>
            <el-table class="l-table" :data="jobHistoryPriceList" style="width: 100%"  size="mini" max-height="500px">
              <el-table-column prop="name" label="员工入职时间" align="left" width="130">
                <template slot-scope='{row}'>
                  <div>{{row.agent_start_date}} -</div>
                  <div>{{row.agent_end_date}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="agent_price" label="代理单价" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.agent_price}}{{row.agent_price_unit_cn}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="agent_cost_period" label="代理费用期" align="center">
                <template slot-scope='{row}'>
                  <span v-if='row.agent_cost_period'>{{row.agent_cost_period}}个月</span>
                  <span v-else>/</span>
                </template>
              </el-table-column>

              <el-table-column prop="price" label="开发费用" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.price}}{{row.price_unit_cn}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="cost_period" label="开发费用期" align="center">
                <template slot-scope='{row}'>
                  <span v-if='row.cost_period'>{{row.cost_period}}个月</span>
                  <span v-else>/</span>
                </template>
              </el-table-column>

              <el-table-column prop="calculate_days" label="多少天起算费用" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.calculate_days}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="admin_name" label="" align="center" width="105">
                <template slot-scope='{row}'>
                  <el-button type="primary" size="mini" @click="openPriceRecruitNumDialog(row)">招聘人数</el-button>
                </template>
              </el-table-column>

              <el-table-column prop="addtime" label="操作时间" align="center" width="100"></el-table-column>
              <el-table-column prop="admin_name" label="操作人" align="center"></el-table-column>


            </el-table>
          </div>
        </div>

      </el-col>
      </el-row>

    </el-dialog>
    <!-- 设置代理价格弹窗end -->

    <!-- 设置代理价格招聘要求弹窗 start -->
    <el-dialog class="el-dialog-larger" title="设置代理价格招聘人数" :visible.sync="dialogVisiablePriceRecruitNum" >
      <el-row>
      <el-col :span="10">
        <el-card>
          <el-form :model="jobPriceRecruitNumInfo" label-width="130px" :rules="jobPriceRecruitNumInfoRules" ref="jobPriceRecruitNumInfo">
            <el-form-item label="员工入职时间" prop="agentPriceTime" >
              <el-date-picker disabled v-model="jobPriceRecruitNumInfo.agentPriceTime" type="daterange" range-separator="-" start-placeholder="开始日期"
                end-placeholder="结束日期" value-format="yyyy-MM-dd" style="width: 320px;">
              </el-date-picker>
            </el-form-item>

            <el-form-item label="招聘人数" prop="agent_recruit_num">
              <el-input v-model="jobPriceRecruitNumInfo.agent_recruit_num" type="number" > <template slot="append">个</template></el-input>
              <el-link type="warning" :underline="false">注：招聘人数，表示对应的单价要求招聘的人数。</el-link>

            </el-form-item>

            <el-divider></el-divider>

            <!-- <el-form-item label="代理单价" prop="agent_price">
              <el-input v-model="jobPriceRecruitNumInfo.agent_price" type="number" :placeholder="'默认'+defaultPrice.agent_price"> <template slot="append">元/小时</template></el-input>
            </el-form-item> -->

            <div class="price" >
              <el-form-item  label="代理单价" prop="agent_price">
                <el-input v-model="jobPriceRecruitNumInfo.agent_price" type="number" :placeholder="'默认'+defaultPrice.agent_price">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="agent_price_unit"  style="margin-left:-120px">
              <el-select disabled v-model="jobPriceRecruitNumInfo.agent_price_unit"   placeholder="请选择单位"    >
                <el-option label="元/时" :value="1"></el-option>
                <el-option label="元/月" :value="2"></el-option>
              </el-select>
              </el-form-item>
            </div>



            <el-form-item label="代理费用期" prop="agent_cost_period" >
              <el-input disabled v-model="jobPriceRecruitNumInfo.agent_cost_period" type="number"> <template slot="append">个月</template></el-input>
            </el-form-item>

            <el-divider></el-divider>

            <!-- <el-form-item label="代理开发费用" prop="price">
              <el-input v-model="jobPriceRecruitNumInfo.price" type="number" :placeholder="'默认'+defaultPrice.price"> <template slot="append">元/小时</template></el-input>
            </el-form-item> -->
            <div class="price" >
              <el-form-item label="代理开发费用" prop="price">
                <el-input v-model="jobPriceRecruitNumInfo.price" type="number" :placeholder="'默认'+defaultPrice.price">
                </el-input>
              </el-form-item>
              <el-form-item label="" prop="price_unit"  style="margin-left:-120px">
              <el-select disabled v-model="jobPriceRecruitNumInfo.price_unit"   placeholder="请选择单位"    >
                <el-option label="元/时" :value="1"></el-option>
                <el-option label="元/月" :value="2"></el-option>
              </el-select>
              </el-form-item>
            </div>


            <el-form-item label="开发费用期" prop="cost_period">
              <el-input disabled v-model="jobPriceRecruitNumInfo.cost_period" type="number"> <template slot="append">个月</template></el-input>
            </el-form-item>


            <el-form-item  label="多少天起算费用" prop="calculate_days">
              <el-input disabled v-model="jobPriceRecruitNumInfo.calculate_days" type="number">
              </el-input>
            </el-form-item>


            <el-form-item>
              <el-button type="primary" @click="submitAgentPriceRecruit('jobPriceRecruitNumInfo')">确 定</el-button>
              <el-button @click="dialogVisiablePriceRecruitNum = false">取 消</el-button>
            </el-form-item>



          </el-form>
        </el-card>
      </el-col>

      <el-col :span="14">
        <div class="l-panel">
                <div class="panel-body">
                  <div>历史记录</div>
            <el-table class="l-table" :data="jobHistoryPriceRecruitNumList" style="width: 100%"  size="mini" max-height="500px">
              <el-table-column prop="name" label="员工入职时间" align="left" width="130">
                <template slot-scope='{row}'>
                  <div>{{row.agent_start_date}} -</div>
                  <div>{{row.agent_end_date}}</div>
                </template>
              </el-table-column>
              <el-table-column prop="agent_price" label="代理单价" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.agent_price}}{{row.agent_price_unit_cn}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="agent_cost_period" label="代理费用期" align="center">
                <template slot-scope='{row}'>
                  <span v-if='row.agent_cost_period'>{{row.agent_cost_period}}个月</span>
                  <span v-else>/</span>
                </template>
              </el-table-column>

              <el-table-column prop="price" label="开发费用" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.price}}{{row.price_unit_cn}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="cost_period" label="开发费用期" align="center">
                <template slot-scope='{row}'>
                  <span v-if='row.cost_period'>{{row.cost_period}}个月</span>
                  <span v-else>/</span>
                </template>
              </el-table-column>


              <el-table-column prop="calculate_days" label="多少天起算费用" align="left" width="90">
                <template slot-scope='{row}'>
                  <span>{{row.calculate_days}}</span>
                </template>
              </el-table-column>

              <el-table-column prop="agent_recruit_num" label="招聘人数" align="center" ></el-table-column>

              <el-table-column prop="addtime" label="操作时间" align="center" width="100"></el-table-column>
              <el-table-column prop="admin_name" label="操作人" align="center"></el-table-column>

            </el-table>
          </div>
        </div>

      </el-col>
      </el-row>

    </el-dialog>
    <!-- 设置代理价格招聘要求弹窗 end -->

    <!-- 设置代理价格咨询电话 start -->
        <el-dialog title="设置代理价格咨询电话" :visible.sync="isShowDialogContact" width="40%">
          <el-form :model="priceContactForm" ref="priceContactForm" :rules="priceContactFormRules" label-width="100px">
            <el-form-item label="咨询人:" prop="agent_price_contact">
              <el-input v-model="priceContactForm.agent_price_contact"></el-input>
            </el-form-item>
            <el-form-item label="咨询电话:" prop="agent_price_telephone">
              <el-input v-model="priceContactForm.agent_price_telephone"></el-input>
            </el-form-item>

          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="isShowDialogContact = false">取 消</el-button>
            <el-button type="primary" @click="sumbitPriceContact('priceContactForm')">确 定</el-button>
          </div>
        </el-dialog>
    <!-- 设置代理价格咨询电话 end -->


<!-- 职位详情 start -->
    <el-dialog class="el-dialog-medium-x" title="职位详情" :visible.sync="isShowDialogJobsDetails" >
      <div class="jobs-details-container" style="min-height: 500px;">
        <div class="e-update-date">
          <div class="update-date">更新时间：{{jobsDetailsInfo.refreshtime}}</div>
          <el-button @click="handleEdit(jobsDetailsInfo.id)"  class="edit-btn" size="medium">编辑</el-button>
        </div>

        <el-tabs v-model="activeTabName" >
          <el-tab-pane label="职位详情" name="first">
            <div>
              <div class="e-jobs-name" >
                <div class="jobs-name">{{jobsDetailsInfo.jobs_name}}</div>
                <div class="wage">{{jobsDetailsInfo.wage_cn}}<span>{{jobsDetailsInfo.wage_cn_unit}}</span></div>
              </div>
              <div class="e-jobs-demand">
                 <span>{{jobsDetailsInfo.district_cn1}}-{{jobsDetailsInfo.district_cn2}}-{{jobsDetailsInfo.district_cn3}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{jobsDetailsInfo.experience_cn?jobsDetailsInfo.experience_cn:"经验不限"}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>{{jobsDetailsInfo.education_cn?jobsDetailsInfo.education_cn:"学历不限"}}</span>
                    <el-divider direction="vertical"></el-divider>
                    <span>招{{jobsDetailsInfo.amount}}人</span>

              </div>
              <div class="e-jobs-tags">
                <el-tag v-for="(item,index) in jobsDetailsInfo.tag_cn" :key="index" type="primary">{{item}}</el-tag>

              </div>

              <div class="row-line"></div>

              <div class="e-companyname">{{jobsDetailsInfo.companyname}}</div>
              <div class="e-company-type">
                 <span>{{jobsDetailsInfo.c_nature_cn}}</span>
                 <el-divider v-if="jobsDetailsInfo.c_nature_cn" direction="vertical"></el-divider>
                 <span>{{jobsDetailsInfo.trade_cn}}</span>
                 <el-divider v-if="jobsDetailsInfo.trade_cn" direction="vertical"></el-divider>
                 <span>{{jobsDetailsInfo.scale_cn}}</span>
              </div>
              <div class="e-company-address">
                <i class="el-icon-location"></i>
                <span>{{jobsDetailsInfo.district_cn1}}-{{jobsDetailsInfo.district_cn2}}-{{jobsDetailsInfo.district_cn3}} {{jobsDetailsInfo.address}}</span>
              </div>

               <div class="row-line"></div>
               <div class="e-desc-title">职位描述</div>
               <div class="e-desc-text" v-html="jobsDetailsInfo.contents"></div>
                <div class="e-desc-title">岗位要求</div>
                <div class="e-desc-text" v-html="jobsDetailsInfo.jobs_require"></div>
                <div class="e-desc-title">福利待遇</div>
                <div class="e-desc-text" v-html="jobsDetailsInfo.jobs_welfare"> </div>
                <div class="e-desc-title">环境图片</div>
                <div class="e-company-img">
                  <img v-for="(item,index) in jobsDetailsInfo.imgwork" :key="index" style="height: 150px;" :src="item" />

                </div>

            </div>

          </el-tab-pane>
          <el-tab-pane label="招聘话术" name="second">
            <div>
              <div v-for="(item,index) in jobsDetailsInfo.speechcraft">
                <div class="e-desc-title">{{item.firsttype}}</div>
                <div class="e-desc-text" v-html="item.secondtype">

                </div>
              </div>


            </div>
          </el-tab-pane>
        </el-tabs>


      </div>
    </el-dialog>
<!-- 职位详情 end -->

<!--设置 是否允许代理招聘 start -->
    <el-dialog class="el-dialog-medium" title="是否允许代理招聘" :visible.sync="dialogVisibleSettingAgentRecuit" >
      <el-radio-group v-model="isAgentRecuit">
        <el-radio :label="1">允许代理招聘</el-radio>
        <el-radio :label="0">取消代理招聘</el-radio>

      </el-radio-group>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisibleSettingAgentRecuit = false">取 消</el-button>
        <el-button type="primary" @click="sumbitSettingAgentRecuit">确 定</el-button>
      </div>
    </el-dialog>
<!-- 设置 是否允许代理招聘 end -->





  </div>

</template>

<script>
  import {
    WebUrl
  } from '@/api/index';
  import $ from 'jquery'
  import Message from '@/utils/message.js';
  export default {
    data: function() {
      return {
        search:{
          audit:"",
          jobtype:"",
          key:"",
          key_type:"",
        },
        dataList:[],
        page: 1, //页码
        total: 1,//总数

        isShowDialogAudit:false,//显示审核弹窗
        auditForm:{
          id:"",
          audit:"",//状态
          remark:"",//备注
        },
        isShowDialogRecommend:false,//显示主推热招弹窗
        recommendForm:{
          id:"",
          jobtype:""
        },
        dialogVisiablePrice:false,//代理价格弹窗
        jobPriceInfo:{
          jobs_id:"",
          price:"",
          priceTime:[],
          start_date:"",
          end_date:"",
          cost_period:"",
          agent_price:"",
          agentPriceTime:[],
          agent_start_date:"",
          agent_end_date:"",
          agent_cost_period:"",
          agent_price_unit:"",
          price_unit:"",
          calculate_days:"",
        },//目前代理价格信息
        jobPriceInfoRules:{
          price: [
            { required: true, message: '请输入代理开发价', trigger: 'blur' },
          ],
          priceTime: [
            { required: true, message: '请选择员工入职时间（上人时间）', trigger: 'blur' }
          ],
          cost_period: [
            { required: true, message: '请输入开发费用期', trigger: 'blur' }
          ],
          price_unit: [
            { required: true, message: '请输入开发价单位', trigger: 'blur' }
          ],
          agent_price: [
            { required: true, message: '请输入代理价格', trigger: 'blur' }
          ],
          agentPriceTime: [
            { required: true, message: '请选择员工入职时间（上人时间）', trigger: 'blur' }
          ],
          agent_cost_period: [
            { required: true, message: '请输入代理费用期', trigger: 'blur' }
          ],
          agent_price_unit: [
            { required: true, message: '请输入代理价单位', trigger: 'blur' }
          ],
          calculate_days: [
            { required: true, message: '请输入多少天起算费用', trigger: 'blur' }
          ],

        },
        defaultPrice:{
          agent_price:0.6
        },
        jobHistoryPriceList:[],//价格历史记录
        dialogVisiablePriceRecruitNum:false,//代理价格-设置招聘人数弹窗
        jobPriceRecruitNumInfo:{
          jobs_id:"",
          price:"",
          priceTime:[],
          start_date:"",
          end_date:"",
          cost_period:"",
          agent_price:"",
          agentPriceTime:[],
          agent_start_date:"",
          agent_end_date:"",
          agent_cost_period:"",
          agent_recruit_num:'',
          pid:"",//父级
          agent_price_unit:"",
          price_unit:"",
          calculate_days:"",
        },//代理价格招聘人数信息
        jobPriceRecruitNumInfoRules:{
          price: [
            { required: true, message: '请输入代理开发价', trigger: 'blur' },
          ],
          priceTime: [
            { required: true, message: '请选择员工入职时间（上人时间）', trigger: 'blur' }
          ],
          cost_period: [
            { required: true, message: '请输入开发费用期', trigger: 'blur' }
          ],
          agent_price: [
            { required: true, message: '请输入代理价格', trigger: 'blur' }
          ],
          agentPriceTime: [
            { required: true, message: '请选择员工入职时间（上人时间）', trigger: 'blur' }
          ],
          agent_cost_period: [
            { required: true, message: '请输入代理费用期', trigger: 'blur' }
          ],
          agent_recruit_num: [
            { required: true, message: '请输入招聘人数', trigger: 'blur' }
          ],

        },
        jobHistoryPriceRecruitNumList:[],//某价格设置招聘人数历史记录


        selectId:[],//批量选择
        isShowDialogJobsDetails:false,//职位详情弹窗
        activeTabName:"first",
        jobsDetailsInfo:{},//职位详情
        dialogVisibleSettingAgentRecuit:false,//设置代理招聘弹窗
        isAgentRecuit:1,//是否给代理招聘：1是，0否
        isShowDialogContact:false,//设置代理价格咨询电话弹窗
        //代理价格咨询电话参数
        priceContactForm:{
          agent_price_telephone:"",
          agent_price_contact:""
        },
        priceContactFormRules:{
          agent_price_contact: [
            { required: true, message: '请咨询人', trigger: 'blur' }
          ],
          agent_price_telephone: [
            { required: true, message: '请填写咨询电话', trigger: 'blur' }
          ]
        },
      }
    },
    activated() {
      this.getList()

    },
    mounted() {

    },
    methods: {
      //显示审核弹窗
      showDialogAudit(id="") {
        this.isShowDialogAudit = true
        this.auditForm.id = id
      },
      //提交审核
      submitAudit() {
        this.post('jobs/checkJobs', this.auditForm)
          .then(res => {
            if (res.data.code == 1) {
              Message.success(res.data.msg);
              var that = this;
              this.getList()
              this.isShowDialogAudit = false;
            } else {
              Message.error(res.data.msg);
            }
          })
      },
      //显示设置推荐类型弹窗
      showDialogRecommend(id="") {
        this.isShowDialogRecommend = true
        this.recommendForm.id = id
      },
      //设置岗位类型
      sumbitRecommend() {
        this.post('jobs/jobsSet', this.recommendForm)
          .then(res => {
            if (res.data.code == 1) {
              Message.success(res.data.msg);
              var that = this;
              this.getList()
              this.isShowDialogRecommend = false;
            } else {
              Message.error(res.data.msg);
            }
          })
      },

      deleteJobs(val){
          this.$confirm('确定删除该职位?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                  this.post('jobs/delJobs',{id:val}).then(res=>{
                    res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
                    this.getList()
                  })
                })
      },

      clearQuery() {
        for(let key in this.search) {
          this.search[key] = "";
        }
        this.page = 1;
        this.getList()
      },
      // 获取操作栏展开收缩之后的高度
      getSearchBarHeight(val) {
        let sHeight = val;
        let fHeight = this.$refs.pageTableFilter ? this.$refs.pageTableFilter.clientHeight : 0;
        this.tableInitHeight = this.$util.setTableHeight(sHeight, fHeight);
      },
      //类型查找
      searchKey() {
        if (!this.search.key_type) {
          return Message.warning('请选择搜索类型')
        }
        this.page = 1
        this.getList()
      },
      //获取列表数据
      getList() {
        let param = {
          page:this.page
        }
        for(let key in this.search) {
          if(this.search[key] !=='') {
            param[key] = this.search[key]
          }
        }
        this.gets('v2/jobs/getJobsList', param)
          .then(res => {
            this.dataList = res.data.data.list;
            this.total = res.data.data.pagination.total
          })
      },

      //添加，编辑
      handleEdit(id){
        if(this.isShowDialogJobsDetails) {
          this.isShowDialogJobsDetails = false;
        }
        if(id){
          var ids=id
        }else{
          var ids = ''
        }
        this.$router.push({
          path:'/addJobs?id='+ids
        })
      },
      //翻页
      handleCurrentChange(val) {
        this.page = val
        this.getList()

      },
      selectChange() {
        this.$forceUpdate()
      },
      //列表选择 发生变化事件
      handleSelectionChange(val) {
        let array = []
        array = val.map((item) => {
          array.push(item.id);
          return array
        })
        if(array.length>0){
          this.selectId = array[array.length - 1]
        }else{
          this.selectId = []
        }

      },
      //是否允许 代理招聘
      handleSettingAgentRecuit() {
        if(this.selectId.length>0) {
          this.dialogVisibleSettingAgentRecuit = true;
        }else{
          Message.warning('请选择要设置的职位')
        }
      },
      //批量设置代理招聘 - 提交
      sumbitSettingAgentRecuit() {
        let param = {
          jobs_id: this.selectId,
          agent_auth: this.isAgentRecuit?1:0
        }
        this.post('v2/jobs/setJobsAgentAuth', param).then(res => {
          Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
          if(res.data.code==1) {
            this.getList()
            this.dialogVisibleSettingAgentRecuit = false;
          }

        })
      },
      //单独设置代理招聘 - 提交
      /*
      sumbitSingleSettingAgentRecuit(row) {
        let param = {
          jobs_id: [row.id],
          agent_auth: row.agent_auth==1?0:1
        }
        this.post('v2/jobs/setJobsAgentAuth', param).then(res => {
          Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
          if(res.data.code==1) {
            this.getList()
            this.dialogVisibleSettingAgentRecuit = false;
          }

        })
      },
      */
     sumbitSingleSettingAgentRecuit(event,row) {
       console.log(event)
       let param = {
         jobs_id: [row.id],
         agent_auth: event
       }
       this.post('v2/jobs/setJobsAgentAuth', param).then(res => {
         Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
         if(res.data.code==1) {
           this.getList()
           this.dialogVisibleSettingAgentRecuit = false;
         }

       })
     },


      //代理价格 - 显示弹窗
      showPriceDialog(row) {
        this.dialogVisiablePrice = true;
        this.jobPriceInfo.jobs_id = row.id;
        this.jobsAgentInfo();
      },
      jobsAgentInfo() {
        let param = {jobs_id:this.jobPriceInfo.jobs_id };
        this.gets('agent/jobsAgentInfo', param)
          .then(res => {
            for(let key in this.jobPriceInfo) {
              if(key!='jobs_id' ) {
                if(key =='priceTime'){
                  if(res.data.data.info.start_date && res.data.data.info.end_date) {
                    this.jobPriceInfo[key] = [res.data.data.info.start_date,res.data.data.info.end_date]
                  }else{
                    this.jobPriceInfo[key] = []
                  }

                }else if(key=='agentPriceTime') {
                  if(res.data.data.info.agent_start_date && res.data.data.info.agent_end_date) {
                    this.jobPriceInfo[key] = [res.data.data.info.agent_start_date,res.data.data.info.agent_end_date]
                  }else{
                    this.jobPriceInfo[key] = []
                  }

                }else{
                  this.jobPriceInfo[key] = res.data.data.info[key]
                }

              }
            }
            if(this.jobPriceInfo.price==0 || this.jobPriceInfo.price=='0.00') {
              this.jobPriceInfo.price = '';
            }
            if(this.jobPriceInfo.agent_price==0 || this.jobPriceInfo.agent_price=='0.00') {
              this.jobPriceInfo.agent_price = '';
            }
            this.defaultPrice = res.data.data.default;
            this.jobHistoryPriceList = res.data.data.priceHistoryList;

          })
      },
      //代理价格 - 设置提交
      submitAgentPrice(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let url = "agent/editJobsAgentPrice";
            let {
              priceTime,
              agentPriceTime
            } = this.jobPriceInfo;
            priceTime.length == 2 ? this.jobPriceInfo.start_date = priceTime[0] : '';
            priceTime.length == 2 ? this.jobPriceInfo.end_date = priceTime[1] : '';
            agentPriceTime.length == 2 ? this.jobPriceInfo.agent_start_date = agentPriceTime[0] : '';
            agentPriceTime.length == 2 ? this.jobPriceInfo.agent_end_date = agentPriceTime[1] : '';
            this.post(url, this.jobPriceInfo).then(res => {
              Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
              if(res.data.code==1) {
                this.jobsAgentInfo()
              }

            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });


      },
      //代理价格 - 招聘人数设置弹窗-显示
      openPriceRecruitNumDialog(row) {
        this.dialogVisiablePriceRecruitNum = true;
       // console.log("代理价格",row)
        for(let key in this.jobPriceRecruitNumInfo) {
          if(key=='pid') {
            this.jobPriceRecruitNumInfo[key] = row['id']
          }else if(key =='priceTime'){
            if(row.start_date && row.end_date) {
              this.jobPriceRecruitNumInfo[key] = [row.start_date,row.end_date]
            }else{
              this.jobPriceRecruitNumInfo[key] = []
            }

          }else if(key=='agentPriceTime') {
            if(row.agent_start_date && row.agent_end_date) {
              this.jobPriceRecruitNumInfo[key] = [row.agent_start_date,row.agent_end_date]
            }else{
              this.jobPriceRecruitNumInfo[key] = []
            }

          }else{
            this.jobPriceRecruitNumInfo[key] = row[key]
          }
          this.jobPriceRecruitNumInfo.agent_recruit_num = '';//招聘人数清空


          if(this.jobPriceRecruitNumInfo.price==0 || this.jobPriceRecruitNumInfo.price=='0.00') {
            this.jobPriceRecruitNumInfo.price = '';
          }
          if(this.jobPriceRecruitNumInfo.agent_price==0 || this.jobPriceRecruitNumInfo.agent_price=='0.00') {
            this.jobPriceRecruitNumInfo.agent_price = '';
          }

        }
        this.jobHistoryPriceRecruitNumList = row.son || [];
      },
      //代理价格 - 招聘人数设置 - 提交
      submitAgentPriceRecruit(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let url = "agent/editJobsAgentPrice";
            let {
              priceTime,
              agentPriceTime
            } = this.jobPriceRecruitNumInfo;
            priceTime.length == 2 ? this.jobPriceRecruitNumInfo.start_date = priceTime[0] : '';
            priceTime.length == 2 ? this.jobPriceRecruitNumInfo.end_date = priceTime[1] : '';
            agentPriceTime.length == 2 ? this.jobPriceRecruitNumInfo.agent_start_date = agentPriceTime[0] : '';
            agentPriceTime.length == 2 ? this.jobPriceRecruitNumInfo.agent_end_date = agentPriceTime[1] : '';
            this.post(url, this.jobPriceRecruitNumInfo).then(res => {
              Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
              if(res.data.code==1) {
                let sonNewAdd = this.jobPriceRecruitNumInfo
                sonNewAdd.agent_price_unit_cn = sonNewAdd.agent_price_unit==1?'元/时':'元/月'
                sonNewAdd.price_unit_cn = sonNewAdd.price_unit==1?'元/时':'元/月'
                this.jobHistoryPriceRecruitNumList.unshift(sonNewAdd)
                //this.jobHistoryPriceRecruitNumList.unshift(this.jobPriceRecruitNumInfo)
                this.jobsAgentInfo()
              }

            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });

      },

      //批量删除职位
      multiDelete(){
        if(this.selectId.length>0){
          this.$confirm('确定删除职位?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.post('v2/jobs/batchDelJobs',{id: this.selectId }).then(res=>{
              res.data.code == 1?Message.success(res.data.msg):Message.warning(res.data.msg)
              this.getList()
            })
          })
        }else{
          Message.warning('请选择要删除的职位')
        }
      },
      //显示职位详情弹窗
      openJobsDetailsDialog(id) {
        this.isShowDialogJobsDetails = true;
        this.getJobsDetails(id)
      },
      getJobsDetails(id) {
        this.gets('v2/jobs/jobsDetail',{id: id }).then(res=>{
          this.jobsDetailsInfo = res.data.data;
        })
      },
      //刷新置顶职位
      refreshJobs(id) {
        this.post('jobs/jobsRefresh',{id: id }).then(res=>{
          let result = res.data;
          if(result.code==1) {
            Message.success(result.msg)
          }else{
            Message.error(result.msg)
          }

        })
      },
      /********设置代理价格咨询电话 start ******************************************/
      showSettingPriceContactDialog() {
        if(this.selectId.length>0) {
          this.isShowDialogContact = true;
        }else{
          Message.warning('请勾选要设置的职位')
        }
      },
      //提交
      sumbitPriceContact(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            let url = "agent/setJobsAgentPriceContact";
            let params = {
              id: this.selectId
            }
            for(let key in this.priceContactForm) {
              params[key] = this.priceContactForm[key];
            }

            this.post(url, params).then(res => {
              Message[res.data.code == 1 ? 'success' : 'warning'](res.data.msg)
              if(res.data.code==1) {
                for(let key in this.priceContactForm) {
                  this.priceContactForm[key] = ''
                }
                this.isShowDialogContact = false;
                this.getList()
              }


            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      },
      /********设置代理价格咨询电话 end ********************************************/


    }
  }
</script>
<style lang="scss" src="../../style/page/jobDetails.scss"></style>
<style scoped>
  .pagination {
    margin: 20px auto;
    width: 100%;
    text-align: center;
  }

  .resumeType {
    display: flex;
    height: 45px;
    align-items: center;
    font-size: 20px;
  }

  .btn>.el-button {
    margin: 5px;
  }

  .el-pagination__rightwrapper {
    float: left !important
  }

  .exportBtn {
    float: right;
  }

</style>



// WEBPACK FOOTER //
// src/view/jobsManage/companyJobsList.vue